import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// SPA oldalváltás-követés minden platformhoz.
// Ezt a komponenst a BrowserRouter belsejéből kell meghívni (lásd App.jsx).
export function useAnalytics() {
  const location = useLocation()

  useEffect(() => {
    const path = location.pathname + location.search

    // Google Analytics 4 – manuális page_view (send_page_view: false az index.html-ben)
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path:     path,
        page_location: window.location.href,
        page_title:    document.title,
      })
    }

    // Meta (Facebook) Pixel – PageView minden útvonalváltásnál
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView')
    }

    // TikTok Pixel – page() minden útvonalváltásnál
    if (typeof window.ttq !== 'undefined' && typeof window.ttq.page === 'function') {
      window.ttq.page()
    }

    // Microsoft Clarity – automatikusan követi az SPA navigációt, nincs teendő
  }, [location])
}
